require('./detailedHistory.i18n.json');
require('./detailedHistoryModal.tpl.html');
require('./detailedHistoryRepository.js');

/*@ngInject*/
const DetailedHistoryModalController = function ($rootScope, $scope, $controller, $filter, $timeout, $window, coreMediator, coreConstant, detailedHistoryRepository, localization) {

    localization.getTranslationByKey('detailedHistory').then(function (translations) {

        var searchFieldsFilters = [
            {name: _.get(translations, 'searchFieldsFilters.byUser'), value: 1},
            {name: _.get(translations, 'searchFieldsFilters.byType'), value: 4},
            {name: _.get(translations, 'searchFieldsFilters.byMessage'), value: 2}
        ];

        $scope.columns = [{
            name: 'timeCreated',
            label: _.get(translations, 'grid.columns.colDate'),
            className: 'colDate',
            getValue: function (item) {
                return $filter('date')(item.timeCreated, 'MM/dd/yy hh:mma');
            }
        }, {
            name: 'actorName',
            label: _.get(translations, 'grid.columns.colUser'),
            className: 'colUser',
            getValue: function (item) {
                return item.actorName;
            }
        }, {
            name: 'eventType',
            label: _.get(translations, 'grid.columns.colType'),
            className: 'colType',
            getValue: function (item) {
                return item.eventType;
            }
        }, {
            name: 'eventAction',
            label: _.get(translations, 'grid.columns.colAction'),
            className: 'colAction',
            getValue: function (item) {
                return item.eventAction;
            }
        }, {
            name: 'message',
            label: _.get(translations, 'grid.columns.colMessage'),
            className: 'colMessage colDefault',
            getValue: function (item) {
                return item.message;
            }
        }, {
            name: 'details',
            label: _.get(translations, 'grid.columns.colDetails'),
            className: 'colDetails colDefault',
            getValue: function (item) {
                return item.details;
            }
        }];

        $scope.viewModel = {
            controller: this,
            searchFieldsFilters: searchFieldsFilters,
            selectedFieldFilter: searchFieldsFilters[0],
            timeRangeCriterionTemplate: {
                'type': 1,
                'name': 'Date Range',
                'description': null,
                'required': false,
                'dataSetName': 'Date Range',
                'isDynamicDataSet': false,
                'variableName': 'tmeRange',
                'uiType': 8,
                'defaultShow': false,
                'allowedRolesConcat': ''
            },
            totalRecords:0,
            requestParams: {
                searchString: '',
                filterFields: 1,
                startIndex: 0,
                pageSize: 25,
                numberOfRows: 25,
                key: 'timeCreated',
                sortType: 'desc',
                timeRange:''
            },
            items: null,
            isGridEmpty: false
        };

        $scope.setStartIndex = function (startIndex) {
            $scope.viewModel.requestParams.startIndex = startIndex;
        };

        $scope.onFieldFilterChange = function (filter) {
            $scope.viewModel.selectedFieldFilter = filter;
            $scope.viewModel.requestParams.filterFields = filter.value;
            $scope.onFilterChange();
        };

        function loadRecords() {
            $scope.isLoading = true;
            $scope.viewModel.items = [];
            detailedHistoryRepository.getDetailedHistory($scope.viewModel.requestParams).then(function (result) {
                $scope.viewModel.items = result.records;
                $scope.viewModel.totalRecords = result.totalRecords;
                $scope.viewModel.isGridEmpty = result.records.length === 0;
                $scope.isLoading = false;
            });
        };

        $scope.resetGridHeaders = function (requestParams) {
            $scope.viewModel.requestParams.key = requestParams.key;
            $scope.viewModel.requestParams.sortType = requestParams.sortType;
            $scope.onFilterChange();
        };

        $scope.onFilterChange = function () {
            loadRecords();
        };

        $scope.onClearSearch = function () {
            $scope.viewModel.requestParams.searchString = '';
            $scope.onFilterChange();
        };

        $scope.onPagingChange = function (event, params) {
            $scope.viewModel.requestParams.startIndex = params.startIndex;
            loadRecords();
        };

        $scope.onSortChange = function ($event, params) {
            $scope.viewModel.requestParams.key = params.key;
            $scope.viewModel.requestParams.sortType = params.sortType;
            loadRecords();
        };

        $scope.onDownloadUrlClick = function(downloadType) {
            if (downloadType === 'csv') {
                detailedHistoryRepository.getDownloadUrl($scope.viewModel.requestParams, 'csv').then((url) => {
                    $window.open(url, '_blank');
                });
            } else if (downloadType === 'xls') {
                detailedHistoryRepository.getDownloadUrl($scope.viewModel.requestParams, 'xls').then((url) => {
                    $window.open(url, '_blank');
                });
            }
        };

        $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
            $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
        });

        $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

        $scope.$on(coreConstant.event.FILTER_UPDATED, function (event) {
            $scope.viewModel.requestParams.timeRange = $scope.viewModel.timeRangeCriterionTemplate.value;
            $scope.onFilterChange();
        });
        loadRecords();
    });
};

angular.module('ums.configuration')
    .controller('detailedHistoryModalController', DetailedHistoryModalController);
